import { defineMessage } from 'services/localization';

export const resolutionColumnMessages = {
    onReview: defineMessage('on_review'),
    onApproval: defineMessage('on_approval'),
    rejected: defineMessage('rejected'),
    approved: defineMessage('approved'),
    cancelled: defineMessage('cancelled'),
    onHold: defineMessage('on_hold'),
};

export const qboPOStatusColumnMessages = {
    qboPurchaseOrderStatusOptionOpen: defineMessage('open'),
    qboPurchaseOrderStatusOptionClosed: defineMessage('closed'),
};

export const messages = {
    qboTaxColumn: defineMessage('amounts_are'),
    taxColumn: defineMessage('amounts_are_tax'),
    taxAmount: defineMessage('tax_amount'),
    vendor: defineMessage('vendor'),
    contact: defineMessage('contact'),
    customer: defineMessage('customer'),
    employee: defineMessage('employee'),
    payeeCustomer: defineMessage('payee_customer'),
    payeeEmployee: defineMessage('payee_employee'),
    paymentAccount: defineMessage('payment_account'),
    paymentType: defineMessage('payment_type'),
    paymentMethod: defineMessage('payment_method'),
    paymentStatus: defineMessage('payment_status'),
    requestCurrency: defineMessage('currency'),
    documentCreatedDate: defineMessage('created_date'),
    documentDate: defineMessage('date'),
    serviceDate: defineMessage('service_date'),
    documentDateColumnTitle: defineMessage('document_date_as_shown_in_the_accounting_system'),
    location: defineMessage('location'),
    department: defineMessage('department'),
    name: defineMessage('name'),
    nameColumnTitle: defineMessage('approval_request_full_n_ier_number_of_reference'),
    resolutionBatch: defineMessage('batch_approval_status'),
    resolution: defineMessage('status_1'),
    resolutionColumnTitle: defineMessage('status_of_approval_requ_oved_rejected_cancelled'),
    isBilled: defineMessage('billed'),
    isBilledColumnTitle: defineMessage('indicates_if_purchase_o__approvalmax_or_in_xero'),
    deliveryDate: defineMessage('delivery_date'),
    deliveryDateColumnTitle: defineMessage('delivery_date_for_the_purchase_order'),
    dueDate: defineMessage('due_date'),
    dueDateColumnTitle: defineMessage('document_due_date_as_sh_n_the_accounting_system'),
    isPaid: defineMessage('paid'),
    isPaidColumnTitle: defineMessage('indicates_if_bill_has_been_marked_as_paid_in_xero'),
    plannedPaymentDate: defineMessage('planned_payment_date'),
    plannedPaymentDateColumnTitle: defineMessage('planned_payment_date_set_in_xero'),
    productService: defineMessage('productservice'),
    item: defineMessage('item'),
    description: defineMessage('description'),
    itemDescriptionTitle: defineMessage('item_description'),
    quantity: defineMessage('qty'),
    rate: defineMessage('rate'),
    unitPrice: defineMessage('unit_price'),
    discount: defineMessage('discount'),
    poNumber: defineMessage('purchase_order_number'),
    class: defineMessage('class'),
    category: defineMessage('category'),
    account: defineMessage('account'),
    taxRate: defineMessage('tax_rate'),
    lineItemTrackings1: defineMessage('tracking_category'),
    lineItemTrackings2: defineMessage('tracking_category_1'),
    amount: defineMessage('amount'),
    totalAmount: defineMessage('total_amount'),
    customers: defineMessage('customers'),
    lineItemIsMatched: defineMessage('line_item_matched'),
    matched: defineMessage('matched'),
    poStatus: defineMessage('purchase_order_status'),
    batchPaymentStatus: defineMessage('batch_payment_status'),
    beneficiary: defineMessage('beneficiary'),
    billCurrency: defineMessage('bill_currency'),
    sourceCurrency: defineMessage('source_currency'),
    purpose: defineMessage('purpose'),
    wagesOrSalary: defineMessage('wages_or_salary'),
    xeroBankAccount: defineMessage('xero_bank_account'),
    feeAmount: defineMessage('fee_amount'),
    sourceAmount: defineMessage('source_amount'),
    bill: defineMessage('bill'),
    billAmount: defineMessage('bill_amount'),
    feeType: defineMessage('fee_type'),
    paymentReference: defineMessage('payment_reference'),
    contactColumnTitle: defineMessage('supplier_vendor_in_case__of_accounts_receivable'),
    isAcceptedColumnName: defineMessage('customer_decision'),
    isAcceptedColumnTitle: defineMessage('customer_decision'),
    isAcceptedTrue: defineMessage('accepted'),
    isAcceptedFalse: defineMessage('declined'),
    sumOfAllocationsName: defineMessage('sum_of_all_allocations'),
    sumOfAllocationsTitle: defineMessage('sum_of_all_allocations'),
    purchaseOrderBalanceColumnName: defineMessage('po_remaining_balance'),
    purchaseOrderBalanceColumnTitle: defineMessage('amount_of_the_purchase__what_is_left_to_be_paid'),
    matchedBillsColumnName: defineMessage('matched_bills'),
    matchedBillsColumnTitle: defineMessage('bills_matched_with_the_purchase_order'),
    matchedBillsBalanceName: defineMessage('bill_remaining_balance'),
    matchedBillsBalanceTitle: defineMessage('bill_remaining_balance'),
    matchedPurchaseOrdersColumnName: defineMessage('matched_purchase_orders'),
    matchedPurchaseOrdersColumnTitle: defineMessage('purchase_orders_matched_with_the_bill'),
    grnColumnName: defineMessage('grn_status'),
    grnColumnTitle: defineMessage('grn_status'),
    grnNotReceived: defineMessage('not_received'),
    grnPartiallyReceived: defineMessage('partially_received'),
    grnFullyReceived: defineMessage('fully_received'),
    grnStatusDateColumnName: defineMessage('grn_status_date'),
    grnStatusDateColumnTitle: defineMessage('grn_status_date'),
    retrospectivePurchaseOrderColumnName: defineMessage('is_retrospective'),
    retrospectivePurchaseOrderColumnTitle: defineMessage('this_field_shows_if_the_dated_prior_the_po_date'),
    netRemainingBalanceName: defineMessage('net_remaining_balance'),
    netRemainingBalanceTitle: defineMessage('net_remaining_balance'),
    grossRemainingBalanceName: defineMessage('gross_remaining_balance'),
    grossRemainingBalanceTitle: defineMessage('gross_remaining_balance'),
    amountDueColumnName: defineMessage('amount_due'),
    amountDueColumnTitle: defineMessage('amount_due'),
    netAmountName: defineMessage('net_amount'),
    netAmountTitle: defineMessage('net_amount'),
    grossAmountName: defineMessage('gross_amount'),
    grossAmountTitle: defineMessage('gross_amount'),
    paymentAmount: defineMessage('payment_amount'),
    paymentDate: defineMessage('payment_date'),
    bankAccount: defineMessage('bank_account'),
    paymentDetails: defineMessage('payment_details'),
    amaxPayBatchPaymentStatusNone: defineMessage('none'),
    amaxPayBatchPaymentStatusAwaitingPayment: defineMessage('awaiting_payment'),
    amaxPayBatchPaymentStatusProcessing: defineMessage('processing'),
    amaxPayBatchPaymentStatusPartiallyPaid: defineMessage('partially_paid'),
    amaxPayBatchPaymentStatusPaid: defineMessage('paid'),
    amaxPayBatchPaymentStatusFailed: defineMessage('failed'),
    amaxPayBatchPaymentStatusCancelled: defineMessage('cancelled'),
    amaxPayBatchPaymentBillCurrency: defineMessage('bill_currency'),
    amaxPayLinePaymentStatus: defineMessage('payment_status'),
    amaxPayLinePaymentStatusNone: defineMessage('none'),
    amaxPayLinePaymentStatusReadyToPay: defineMessage('ready_to_pay'),
    amaxPayLinePaymentStatusProcessing: defineMessage('processing'),
    amaxPayLinePaymentStatusScheduled: defineMessage('scheduled'),
    amaxPayLinePaymentStatusPaid: defineMessage('paid'),
    amaxPayLinePaymentStatusFailed: defineMessage('failed'),
    amaxPayLinePaymentStatusCancelled: defineMessage('cancelled'),
    narrationColumnName: defineMessage('narration'),
    narrationColumnTitle: defineMessage('narration'),
    debitAmountName: defineMessage('debit_amount'),
    debitAmountTitle: defineMessage('debit_amount'),
    creditAmountName: defineMessage('credit_amount'),
    creditAmountTitle: defineMessage('credit_amount'),
    showOnCashBasisReportsColumnName: defineMessage('show_journal_on_cash_basis_reports'),
    showOnCashBasisReportsColumnTitle: defineMessage('show_journal_on_cash_basis_reports'),
    yes: defineMessage('yes'),
    no: defineMessage('no'),
    totalCreditTaxColumnName: defineMessage('total_credit_tax'),
    totalCreditTaxColumnTitle: defineMessage('total_credit_tax'),
    totalDebitTaxColumnName: defineMessage('total_debit_tax'),
    totalDebitTaxColumnTitle: defineMessage('total_debit_tax'),
    debitTaxColumnName: defineMessage('debit_tax'),
    debitTaxColumnTitle: defineMessage('debit_tax'),
    creditTaxColumnName: defineMessage('credit_tax'),
    creditTaxColumnTitle: defineMessage('credit_tax'),
    taxNameColumnName: defineMessage('tax_name'),
    taxNameColumnTitle: defineMessage('tax_name'),
    numberColumnName: defineMessage('number'),
    numberColumnTitle: defineMessage('number'),
    receivedByName: defineMessage('received_by'),
    receivedByColumnTitle: defineMessage('received_by'),
    netSuiteCurrencyColumnName: defineMessage('currency_full_name'),
    netSuiteCurrencyColumnTitle: defineMessage('currency_full_name'),
    netSuiteDocumentStatusColumnName: defineMessage('netsuite_status'),
    netSuiteDocumentStatusColumnTitle: defineMessage('netsuite_status'),
    netSuiteExpenseCategoryColumnName: defineMessage('category'),
    netSuiteExpenseCategoryColumnTitle: defineMessage('category'),
    netSuiteItemColumnName: defineMessage('item'),
    netSuiteItemColumnTitle: defineMessage('item'),
    netSuiteEmployeeColumnName: defineMessage('employee'),
    netSuiteEmployeeColumnTitle: defineMessage('employee'),
};
